import "./index.less"
import "./indexMobile.less"
import {useNavigate} from 'react-router-dom';
import {isMobile} from "react-device-detect";

export default ({index, number, title, desc, url, callBack}) => {
    const style = index > 0 ? {marginTop: '36px'} : {}
    const navigate = useNavigate();

    const clickEvent = () => {
        navigate(url);
        callBack();
        window.fullpage_api.reBuild(true);
        console.log(window.fullpage_api);
    }

    return <>
        {!isMobile && <div className="container" onClick={clickEvent} style={style}>
            <div className="number">{number}</div>
            <div className="text">
                <div className="large-text">{title}</div>
                <div className="small-text">{desc}</div>
                <div className="hover-mask">
                    <div className="arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="14" viewBox="0 0 37 14" fill="none">
                            <path d="M36.5 2.75H1C4.5 3.08333 11.5 5.65 11.5 13.25" stroke="#E35113" stroke-width="4"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>}

        {isMobile && <div className="container-mobile" onClick={clickEvent} style={style}>
            <div className="number-mobile">{number}</div>
            <div className="text-mobile">
                <div className="large-text-mobile">{title}</div>
                <div className="small-text-mobile">{desc}</div>
                <div className="hover-mask-mobile">
                    <div className="arrow-mobile">
                        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="14" viewBox="0 0 37 14" fill="none">
                            <path d="M36.5 2.75H1C4.5 3.08333 11.5 5.65 11.5 13.25" stroke="#E35113" stroke-width="4"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>}
    </>
}